import { useDownloadCsv } from '@fukuri-admins/hooks/common';

type Options = {
  onSuccess?: (blob: Blob) => void;
  onError?: (error: Error) => void;
  /** 指定時は URL に `?encoding=sjis` を付与する */
  encoding?: 'sjis';
};

/**
 * 利用者一覧 CSV ダウンロード hook
 *
 * テンプレート CSV（UTF-8 / Shift-JIS）ダウンロードおよび利用者一覧 CSV エクスポートに共用する。
 * エンドポイントは `/api/v1/${threeLetterCode}/client_admins/users.csv`。
 * `onSuccess` に渡す `blob` を `downloadFile` に渡すことでファイル名を指定できる。
 *
 * @param threeLetterCode - 3文字コード
 * @param options - 成功時 / 失敗時コールバック。`encoding: 'sjis'` を指定すると Shift-JIS でダウンロードする
 */
export const useGetUsersCsv = (threeLetterCode: string, options?: Options) => {
  const { encoding, ...rest } = options ?? {};
  const url = `/api/v1/${threeLetterCode}/client_admins/users.csv${encoding === 'sjis' ? '?encoding=sjis' : ''}`;
  return useDownloadCsv(url, rest);
};
